// removed by extract-text-webpack-plugin
module.exports = {"hidden":"_3frBA","visuallyhidden":"_21k1P","hide-text":"_1OqdU","center":"_1td-U","noprint":"MkKo6","text":"_2CUa2"};


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/ui-text/styles/Text.scss
 ** module id = 957
 ** module chunks = 1
 **/